import {Directive, ElementRef, EventEmitter, OnInit, Output} from '@angular/core';

@Directive({
  selector: '[onEditableFocusable]',
})
export class EditableFocusEventDirective implements OnInit {
  @Output() onEditableFocusable = new EventEmitter<ElementRef>();
  constructor(private readonly el: ElementRef) {}

  ngOnInit(): void {
    this.el.nativeElement.focus();
    this.onEditableFocusable.emit(this.el);
  }
}

@Directive({
  selector: '[editableFocusable]',
})
export class EditableFocusDirective implements OnInit {
  constructor(private readonly el: ElementRef) {}

  ngOnInit(): void {
    this.el.nativeElement.focus();
  }
}
